import React from 'react';
import { Container, Row, Col } from "react-bootstrap";
import "../assets/css/expertise.css";

const expertise = [
  {
    image: require("../assets/images/products/Split_Air_Conditioner.jpg"),
    title: "Split Air Conditioners",
    description: "Energy-efficient split AC systems with advanced cooling technology and smart climate control features.",
  },
  {
    image: require("../assets/images/products/Window_Air_Conditioner.jpg"),
    title: "Window Air Conditioners",
    description: "Compact window-mounted units perfect for single rooms, featuring quick installation and reliable performance.",
  },
  {
    image: require("../assets/images/products/Ceiling Concealed.jpg"),
    title: "Ceiling Concealed",
    description: "High-performance concealed ceiling ducted systems for seamless integration into commercial spaces.",
  },
  {
    image: require("../assets/images/products/City Multi VRF System.jpg"),
    title: "City Multi VRF System",
    description: "City Multi VRF System offers high-capacity ducted systems for whole-building climate control with advanced air distribution and precision.",
  },
  {
    image: require("../assets/images/products/Floor Standing.jpg"),
    title: "Floor Standing",
    description: "Free-standing floor-mounted units providing efficient, reliable, and quiet climate control for commercial spaces.",
  },
  {
    image: require("../assets/images/products/Ceiling Cassette.jpg"),
    title: "Ceiling Cassette",
    description: "Advanced climate control solutions designed for large-scale commercial buildings and manufacturing sites, ensuring optimal performance and energy efficiency.",
  },
  {
    image: require("../assets/images/products/High Static Ductable.webp"),
    title: "High Static Ductable",
    description: "Precise temperature control & humidity regulation for storage facilities & industrial refrigeration.",
  },
  {
    image: require("../assets/images/products/Lossnay & Ventilation Products.jpg"),
    title: "Lossnay & Ventilation Products",
    description: "Precision air handling units for controlled environments and laboratory facilities.",
  },
];

const Expertise = () => {
  return (
    <section id="expertise" className="expertise-section py-5">
      <Container>
        <div className="section-header text-center mb-5">
          <h2 className="section-title mb-3">Premium Air Conditioning & Ventilation Solutions</h2>
        </div>

        <Row className="g-4">
          {expertise.map((exp, index) => (
            <Col key={index} lg={3} md={4} sm={6}>
              <div className="expertise-card h-100 rounded-4 shadow transition-all">
                <div className="card-image-wrapper overflow-hidden position-relative" style={{ height: "200px" }}>
                  <img 
                    src={exp.image} 
                    alt={exp.title} 
                    className="card-image object-fit-cover w-100 h-100 transition-all"
                    loading="lazy" // Lazy loading applied here
                  />
                  <div className="hover-overlay position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center opacity-0">
                    <a href="/contact" className="btn btn-primary">Learn More</a>
                  </div>
                </div>
                <div className="card-content p-3">
                  <h4 className="card-title">{exp.title}</h4>
                  <p className="card-description">{exp.description}</p>
                </div>
              </div>
            </Col>
          ))}
        </Row>

        <div className="text-center mt-5">
          <a href="/contact" className="btn btn-primary consultation-btn">
            <i className="bi bi-headset me-2"></i>Get Expert Consultation
          </a>
        </div>
      </Container>
    </section>
  );
}

export default Expertise;
